import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://lazzdyaxyzqrzmmucwhv.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxhenpkeWF4eXpxcnptbXVjd2h2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE1ODAzNTUsImV4cCI6MjA2NzE1NjM1NX0.eHBW6f3_GmfQa4LeTPHWkh7a5G6aWYIIbFzP8AmI9dw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
}); 